<template>
    <b-modal
        ref="modalConfirm"
        :size="description ? 'md' : 'sm'"
        hide-header
        hide-footer
        centered
        no-close-on-backdrop
        no-fade
    >
        <validation-observer v-slot="{ valid }"  class="text-center">
            <p v-if="useMessage">
                {{ messageText }}
            </p>

            <p v-if="description" class="small">
                {{ description }}
            </p>

            <v-input
                v-if="showUpdateField"
                type="text"
                v-model="updateValue"
                class="mb-2"
                :rules="rules"
                autocomplete="off"
            />

            <b-form-select v-else-if="showSelectField" v-model="updateValue" class="mb-2" :options="selectOptions" />
            <div>
                <slot name="yes-button">
                    <b-button class="button button-success px-3 ml-auto" @click="confirm" :disabled="!valid">
                        {{ yesButtonLabel }}
                    </b-button>
                </slot>

                <b-button v-if="useNoButton" class="button button-danger px-3 ml-3" @click="reject">
                    {{ noButtonLabel }}
                </b-button>
            </div>
        </validation-observer>
    </b-modal>
</template>

<script>
    import VInput from './VInput.vue';

    export default {
        name: 'ConfirmModal',

        components: { VInput },

        props: {
            message: {
                type: String,
                default: ''
            },
            useMessage: {
                type: Boolean,
                default: true
            },
            description: {
                type: String,
                default: ''
            },
            yesButtonText: {
                type: String,
                default: ''
            },
            noButtonText: {
                type: String,
                default: ''
            },
            useNoButton: {
                type: Boolean,
                default: false
            },
            showUpdateField: {
                type: Boolean,
                default: false
            },
            showSelectField: {
                type: Boolean,
                default: false
            },
            selectOptions: {
                type: Array,
                default: () => []
            },
            defaultValue: {
                type: [ Number, String ],
                default: ''
            },
            rules: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                extra: {},
                updateValue: ''
            };
        },

        computed: {
            messageText() {
                return this.message || this.$t('message.areYouSure');
            },

            yesButtonLabel() {
                return this.yesButtonText || this.$t('button.yes');
            },

            noButtonLabel() {
                return this.noButtonText || this.$t('button.no');
            }
        },

        methods: {
            showModal(extra) {
                this.extra = extra || {};
                this.updateValue = this.defaultValue ?? '';
                this.$refs.modalConfirm.show();
            },

            confirm() {
                this.$emit('confirmed', { ...this.extra, updateValue: this.updateValue });
                this.$refs.modalConfirm.hide();
                this.cleanup();
            },

            reject() {
                this.$emit('rejected', this.extra);
                this.$refs.modalConfirm.hide();
                this.cleanup();
            },

            cleanup() {
                this.extra = {};
                this.updateValue = '';
            }
        }
    };
</script>
